module.exports = __webpack_public_path__ + "img/Rectangle@2x.a653a670.png";